/**
 * Fullscreen Layout - layout без bottom menu
 * Используется для форм, деталей, настроек и других страниц, где меню не нужно
 *
 * Страницы сами управляют высотой (h-screen) и внутренним скроллом (overflow-y-auto).
 * Layout предоставляет только ScrollToTop и Suspense — без дополнительных обёрток,
 * чтобы избежать конфликта двойного overflow-y-auto.
 */

import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { LoadingScreen, ScrollToTop } from '@/components';

export function FullscreenLayout(): JSX.Element {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<LoadingScreen hasBottomPadding={false} />}>
        <Outlet />
      </Suspense>
    </>
  );
}